import { roundRect } from './roundRect';

const DELTA_X = 2;
const DELTA_Y = 2;
const SHADOW_COLOR = `rgb(85, 85, 85)`;

export function buttonShadow(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number
): void {
  ctx.save();
  ctx.translate(DELTA_X, DELTA_Y);
  roundRect(ctx, x, y, w, h, r);
  ctx.fillStyle = SHADOW_COLOR;
  ctx.fill();
  ctx.restore();
}
